<template>
  <v-dialog
    :value="value" @input="input => $emit('input', input)"
    width="500"
  >
    <v-card class="flex-column d-flex pa-7 pt-10 pb-20">
      <div class="d-flex align-center justify-center">
        <v-img :src="icon" style="max-width: 80px"></v-img>
        <div class="ml-8 d-flex flex-column">
          <div style="color: #722FFF; font-size: 1.2em;">
            <span v-if="type === 'domain'">Você atingiu o limite de domínios permitidos em seu plano, <strong>{{firstname}}</strong>!</span>
            <span v-else>Você atingiu o limite de links permitidos em seu plano, <strong>{{firstname}}</strong>!</span>
          </div>
          <div class="mt-3 mb-3 grey--text text--darken-1">
            Continue criando e gerenciando seus links, mantendo-os organizados e efetivos. Para isso, basta escolher um dos nossos planos. 
          </div>
          <v-btn class="mt-5" style="width: 200px" depressed color="green darken-2" @click="toPlan()" dark>Fazer upgrade</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: Boolean,
    type: String
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    firstname () {
      return this.user.name.split(' ')[0]
    },
    icon () {
      let src = null

      if (this.type === 'domain') {
        src = '/img/alert/upgrade-domain.svg'
      } else {
        src = '/img/alert/upgrade-plan.svg'
      }

      return src
    }
  },
  methods: {
    toPlan () {
      this.$emit('input', false)
      this.$router.push('/plano?show=true')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>